@if (label) {
  <h6 class="mt-0 mat-body-2 card-label" [id]="idPrefix + '-label'">{{label}}</h6>
}

<!--Card container-->
<div class="scroll-container clean-scroll-bar overyflow-y-auto">
  @if (options$ | async; as options) {
    <div class="card-container fx-column" [id]="idPrefix + '-card-container'">
      <!--Cards-->
      @if (options) {
        @for (option of options; track option; let i = $index) {
          <div class="ml-0 "
            (mouseenter)="onHover(option)" (mouseleave)="onHover()">
            <!-- Each card is 125 x 125 with a 5 px padding ==> 115 x 115 inside-->
            <a class="mat-elevation-z1 card-option clickable mt-2 fx-row y-center fx-gap-sm text-default"
              [class.disabled]="!option.isEnabled"
              [id]="parseId('card-option-' + (option.id || option.text || i))"
              [ngClass]="{'option-selected': option.isSelected}" (click)="selectOption(options, option)">
              <!--Card Image 95 of the 115 px-->
              @if (imageTemplate || option.imageSource || option.selectedImageSource) {
                <div class="image-container ml-2 img-div-width fx-column x-center">
                  <!-- Card Image -->
                  @if (imageTemplate) {
                    <template class="logo-img" [ngTemplateOutlet]="imageTemplate"
                    [ngTemplateOutletContext]="{option: option}"></template>
                  } @else {
                    <!-- A plain name (no slash) is a Material icon name rather than an image URL -->
                    @if (option.imageSource && !option.imageSource.includes('/')) {
                      <div>
                        <button class="md small-icon" color="primary" mat-mini-fab [disabled]="!option.isSelected || option.isSelected"
                          [ngClass]="{'bg-primary': option.isSelected}">
                          <span class="material-icons" [id]="option.imageSource">{{option.imageSource}}</span>
                        </button>
                      </div>
                    } @else {
                      <div>
                        @if (!option.isSelected && option.imageSource) {
                          <img class="logo-img"
                            [src]="option.imageSource" />
                        }
                        @if (option.isSelected && option.selectedImageSource) {
                          <img class="logo-img"
                            [src]="option.selectedImageSource" />
                        }
                      </div>
                    }
                  }
                </div>
              }
              <!--Display Label: Remaining 20 of the 115px-->
              <!-- Card Content -->
              <span class="description-text ml-2 my-0 mat-body-1 text-wrap fx-column y-center fx-1-1-0" [class.link-color]="option.isSelected">
                @if (footerTemplate) {
                  <template [ngTemplateOutlet]="footerTemplate"
                  [ngTemplateOutletContext]="{option: option}"></template>
                } @else {
                  {{ option.text }}
                }
              </span>
              <!-- Actions -->
              @if (!option.model?.isBundled) {
                <mat-icon [color]=" option.isSelected ? 'primary' : undefined">
                  @if (option.isSelected) {
                    {{maxSelect === 1 ? 'radio_button_checked' : 'check_box'}}
                  } @else {
                    {{maxSelect === 1 ? 'radio_button_unchecked' : 'check_box_outline_blank'}}
                  }
                </mat-icon>
              }
            </a>
          </div>
        }
      }
    </div>
  }
</div>
<small class="invalid-feedback d-block" [id]="idPrefix + '-error'" [innerHTML]="errors || '&nbsp;'"></small>
